/**
 * Which outcome-wall sentence a walled lot gets — the lot page's wall and the
 * /results row chip alike. The API decides what is true (`lockOutcome` in
 * catalog.service.ts) and sends two existence flags beside `outcomeLocked`:
 *
 *  - `outcomeHasPrice` — a final price is recorded AND differs from the public
 *    budget. Measured 2026-10-07: on 67.6 % of walled prequest lots the hidden
 *    price equals the budget the page already shows, and synced etender lots
 *    carry no final price at all — «Сумма — в Pro» would sell nothing there.
 *  - `outcomeHasContact` — the winner's org has a phone or an email on file
 *    (40 % have neither).
 *
 * The winner's NAME is behind the wall on every walled lot, so the «neither»
 * sentence still promises something true: who won.
 *
 * An API one deploy behind sends neither flag; that reads as «both», i.e. the
 * pre-flag sentence, rather than under-selling.
 *
 * Literal `t('…')` calls on purpose — `keys-exist.test.ts` only sees literals.
 */
export interface OutcomeLockFlags {
  outcomeHasPrice?: boolean | null;
  outcomeHasContact?: boolean | null;
}

export function outcomeLockText(
  t: (key: string) => string,
  item: OutcomeLockFlags,
  where: 'wall' | 'row',
): string {
  const price = item.outcomeHasPrice !== false;
  const contact = item.outcomeHasContact !== false;
  if (where === 'wall') {
    if (price && contact) return t('tender.outcome.locked');
    if (contact) return t('tender.outcome.lockedContactOnly');
    if (price) return t('tender.outcome.lockedPriceOnly');
    return t('tender.outcome.lockedWhoOnly');
  }
  if (price && contact) return t('tender.outcome.lockedRow');
  if (contact) return t('tender.outcome.lockedRowContact');
  if (price) return t('tender.outcome.lockedRowPrice');
  return t('tender.outcome.lockedRowWho');
}
